
import "D:/erp开发/erp/src/components/Tabs/index.less?modules";
export default {"tabsActions": `tabsActions-rCKOHkjw`,"tabsLeft": `tabsLeft-DvtWcCs6`,"tabsBar": `tabsBar-6MBoUcyL`}
